import React, { useContext, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { Button, Dialog, DialogTitle, DialogActions, DialogContent } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { ParentScreenCtx } from "/src/pages/workbench_build/WorkbenchBuild";
import { api } from '../../../redux/api';
import { treeActions } from '../../../redux/slices/treeSlice';
import { getSelectedNodes } from '../../RightContextMenu/ContextActions/CopyAndPaste';

function ReloadInboundTemplate(props) {
    const parentScreen = useContext(ParentScreenCtx);
    const { account } = useSelector(state => state.queryParams);
    const currentTab = useSelector(state => state.treeData[parentScreen].leftTree.currentTab);
    const { leftTree, rightTree } = useSelector(state => state.treeData[parentScreen]);
    const { selectedKeysArray, translatedData} = rightTree.tree[currentTab];
    const selectedNode = leftTree.tree[currentTab]?.selectedNode;
    const { openModal, toggle } = props;
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const currentScreen = useSelector(state => state.treeData.currentScreen)

    const handleCancelClick = () => {
        toggle();
    }

    const handleRevertSuccess = (paths, savedTemplates) => {
        if (rightTree.path) {
            let templateTypeDispatchAction =  currentScreen === "inbound" ? "getInboundTemplate": currentScreen === "outbound" ? "getOutboundTemplate" : "getWorkflowTree"
            dispatch(treeActions.setRightTreeLoading({ data: true, screen: currentScreen }));
            ["header", "body", "trailer"].forEach((e) => {
                dispatch(
                    treeActions.setRightTreeData({ screen: currentScreen, type: e, data: [] })
                    
                );
                dispatch(
                    treeActions.setRightTreeSelectedNode({ screen: currentScreen, type: e, data: {} })
                );
                dispatch(
                    treeActions.setRightTreeTransData({ screen: currentScreen, type: e, data: [] })
                );
            });

            dispatch(api.endpoints[templateTypeDispatchAction].initiate(
                {
                    account,
                    workflowGroupName: selectedNode.workflowGroup,
                    templateName: selectedNode.title,
                    structonly: false
                },
                { subscribe: false, forceRefetch: true }
            )).then(() => {
                // dispatch(
                //     treeActions.setRightTreeSelectedNode({
                //         screen: parentScreen,
                //         type: currentTab,
                //         data: {},
                //     })
                // );
                // // Select the previous node if available
                // if (selectedKeysArray.length !== 0) {
                //     let key = selectedKeysArray[0].split("-");
                //     if (key[key.length - 1] === "0") {
                //         key?.splice(key.length - 1);
                //         key = key?.join("-");
                //     } else {
                //         key[key.length - 1] = Number(key[key.length - 1]) - 1;
                //         key = key?.join("-");
                //     }

                //     let node = getSelectedNodes([key], translatedData);
                //     if (node[0]) {
                //         setTimeout(() => {
                //             dispatch(
                //                 treeActions.setRightTreeSelectedNode({
                //                     screen: parentScreen,
                //                     type: currentTab,
                //                     data: node[0],
                //                 })
                //             );
                //         });
                //     } else {
                //         const rootNodeMap = {
                //             inbound: "ib-0",
                //             outbound: { header: "obh-0", body: "ob-0", trailer: "obt-0" }[currentTab],
                //             workflow: "wf-0",
                //         }
                //         // If no previous node, select root node
                //         node = getSelectedNodes([rootNodeMap[currentScreen]], translatedData);
                //         setTimeout(() => {
                //             dispatch(
                //                 treeActions.setRightTreeSelectedNode({
                //                     screen: parentScreen,
                //                     type: currentTab,
                //                     data: node[0],
                //                 })
                //             );
                //         });
                //     }
                // }  
            })
            
        }
        // after revert success, set unsaved templates list 
        dispatch(treeActions.setUnsavedTemplates({
            inbound_templates: savedTemplates,
            outbound_templates: [],
            workflow: [],
        }));
    }

    const modifyTemplate = (templatesList, type, processedUnsavedTemplates, savedTemplates) => {
        let temp = {};
        let save = {};
        for (let i = 0; i < templatesList?.length; i++) {
            const obj = templatesList[i];
            if (obj.template === selectedNode.title && obj.workflow_group === selectedNode.workflowGroup) {
                temp = {
                    ...obj,
                    template_type: type,
                    path: `${obj.account}/${obj.workflow_group}/${obj.template}`
                }
            } else {
                save = {
                    ...obj,
                    template_type: type,
                    path: `${obj.account}/${obj.workflow_group}/${obj.template}`
                }
                if (Object.keys(save).length !== 0) savedTemplates?.push(save);
            }
        };
        if (Object.keys(temp).length !== 0) processedUnsavedTemplates?.push(temp);
    }

    const processTemplates = (templates) => {
        let processedUnsavedTemplates = [];
        let savedTemplates = [];
        if (templates.current_state === 'SUCCESS' && templates.data) {
            modifyTemplate(templates.data.inbound_templates, 'inbound', processedUnsavedTemplates, savedTemplates);
            modifyTemplate(templates.data.outbound_templates, 'outbound', processedUnsavedTemplates, savedTemplates);
            modifyTemplate(templates.data.workflow, 'workflow', processedUnsavedTemplates, savedTemplates);
        }
        handleReload(processedUnsavedTemplates, savedTemplates)
    }

    const handleReload = (processedUnsavedTemplates, savedTemplates) => {
        const getProps = (o) => {
            return { account: o.account, workflow_group: o.workflow_group, template: o.template }
        }
        const revertData = {
            inbound_templates: processedUnsavedTemplates?.filter(o => o.template_type === 'inbound').map(getProps),
            outbound_templates: processedUnsavedTemplates?.filter(o => o.template_type === 'outbound').map(getProps),
            workflow: processedUnsavedTemplates?.filter(o => o.template_type === 'workflow').map(getProps),
        }
        dispatch(api.endpoints.revertAllTemplates.initiate(
            { data: revertData },
            { forceRefetch: true }
        )).then((res) => {
            if (res.data?.current_state === "SUCCESS") {
                handleRevertSuccess(processedUnsavedTemplates.map(o => o.path), savedTemplates);
            } else {
                //TODO: handle this failure somehow. will need to figure this out.
                alert('*Dev message* - Backend to revert templates. Check console to debug.');
                console.warn('Revert request failure: ', res);
            }
            dispatch(api.endpoints.getUnsavedTemplates.initiate(
                { account }, { forceRefetch: true }
              ));

        });
        toggle();
    }

    const getTemplateList = () => {
        dispatch(api.endpoints.getUnsavedTemplates.initiate(
            { account }, { forceRefetch: true }
        )).then(response => {
            processTemplates(response.data);
            if (!response.data) console.warn('getUnsavedTemplates no data:', response);
        })
    }

    return (
        <>
            <Dialog open={openModal} maxWidth='xs'>
                <DialogTitle className='dialog-header'>
                    <div className='title'>{t('BOX_CONFIRM')}</div>
                </DialogTitle>
                <DialogContent className='modal-content' dividers>
                    <div>
                        {t('BOX_ARE_YOU_SURE_YOU_WANT_TO_RELOAD_')} <br />
                        <br />
                        <span style={{fontWeight: 'bold'}}>{t(selectedNode?.title)}</span> <br />
                        <br />
                        {t('BOX_ALL_CHANGES_WILL_BE_LOST_SINCE_LAST_SAVE')}
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button
                        size="small"
                        variant="outlined"
                        color="primary"
                        onClick={getTemplateList}
                    > {t('BTN_OK')}
                    </Button>
                    <Button
                        size="small"
                        variant="outlined"
                        color="primary"
                        onClick={() => handleCancelClick()}
                    > {t('CANCEL')}
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}

export default ReloadInboundTemplate;